import ApiUrl from "../../configTools/apiUrl";
const User = JSON.parse(localStorage.getItem("user-info"));

const GetLatestUsed = (setValues)=>{
    fetch(ApiUrl.API_URL_IntrustLastUsed, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        }
      })
        .then(res=>res.json())
        .then(data =>{
            let ListSend = [];
            for (let index = 0; index < data.length; index++) {
            const element = data[index];
                ListSend.push({
                    name: element.name,
                    value: String(element.id)
                })
            }
            setValues(ListSend);
    });
}

export default {GetLatestUsed}